import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalDismissReasons, NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { timeout } from "rxjs/operators";
import { HomeService } from "../home.service";

@Component({
  selector: 'app-user-response-form-view',
  templateUrl: './user-response-form-view.component.html',
  styleUrls: ['./user-response-form-view.component.scss']
})
export class UserResponseFormViewComponent implements OnInit, OnDestroy {
  questionList = [];
  tagName = "";
  SectionList = [];
  forumData: any;
  totalQuestion: number = 0;
  totalFilled: number = 0;
  isSection: boolean = false;
  isLoading: boolean = false;
  isUploading:boolean=false;
  userId: any;
  formId:any;
  circleId:any;
  isFormEdited:any;
  interval:any;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
    size: "lg",
  };
  from = "";
  closeResult: string;
  private modalRef: NgbModalRef;
  name:any
  formResponseId = ""
  constructor(
    private _snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    private homeService: HomeService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {    
    this.route.queryParams.subscribe((param) => {
      this.userId = param["userId"];
      this.formId = param["formId"];
      this.circleId = param['circleId']
      this.formResponseId = param['formResponseId']
      this.name = param['n'];
      this.from = param['from']
      if (param) {
          this.getUserFormEditedDetail();
      }
    });
  }

  responseType:any
  getUserFormEditedDetail() {
    this.isLoading = true
    let query = "";
    if(this.formResponseId && this.formResponseId !== "") {
      query = "?formResponseId="+this.formResponseId;
    } else {
      query = "?formId="+this.formId+"&userId="+this.userId;
    }
    
    this.homeService.getUserFormEditedDetailApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.forumData = res.data.formResponseList;
          this.questionList = this.forumData["response"];
          if (this.questionList["0"]["sectionName"]) {
            this.isSection = true;
            this.SectionList = this.questionList;
          } else {
            this.isSection = false;
          }
        } else {
          this.isLoading = false;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  ngOnDestroy() {
    localStorage.removeItem("question");
  }

  navigateBAck(){
      this.router.navigate(["/main/user-in-forms"],{ queryParams: { formId:this.formId,userId:this.userId,circleId:this.circleId,from:this.from}, preserveQueryParams: false });
    }
    
  isEdit:boolean = false;
  navigateEdit(){
    this.isEdit= !this.isEdit;
  }
 
  getActiveState(item,index) {
    this.questionList = item.response;
          if (this.questionList["0"]["sectionName"]) {
            this.isSection = true;
            this.SectionList = this.questionList;
          } else {
            this.isSection = false;
          }
    // this.validateForum('')
  }

  navigateToFormPage (item) {
    this.router.navigate(["/main/edit-user-multiple-form"],{ queryParams: { formResponseId:item.formResponseId,formId:item.formId,circleId:this.circleId,userId:item.userId,from:this.from,type:'view'}, preserveQueryParams: false });
  }
  
  navigateToAuditPage (item) {
    this.router.navigate(["/main/forms-audit"],{ queryParams: {vId:item.groupedVersionsId,formId:item.formId,formResponseId:item.formResponseId,circleId:this.circleId,userId:item.userId,from:this.from,type:'tab'}, preserveQueryParams: false });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

}
